<template lang="pug">
.bloco-informacoes-adicionais-monitoramento
    .bloco-informacoes-adicionais-monitoramento__interno
        .bloco-informacoes-adicionais-monitoramento__interno-texto
            span.bloco-informacoes-adicionais-monitoramento-interno-texto1 {{ $t('mensagens.comuns.monitoramento.operacaoDeMonitoramento') }}
            .bloco-informacoes-adicionais-monitoramento-interno-texto2.lista-scroll
                span(v-for='(operacao, index) in operacoes', :key='index') {{ operacao }}
</template>

<script>
export default {
    name: 'BlocoInformacoesAdicionaisMonitoramento',
    props: {
        operacoes: {
            type: Array,
            default: () => ''
        }
    },
    data() {
        return {};
    }
};
</script>

<style lang="scss" scoped>
.bloco-informacoes-adicionais-monitoramento {
    min-width: 24%;
    background: var(--white);
    border-radius: 3px;
    display: flex;
    justify-content: space-between;
    min-height: 280px;
    padding: 7px;
    color: var(--primary);
    box-shadow: 0px 0px 2px 0px var(--block-shadow);
    border-radius: 5px;
    border: 1px solid var(--default-border-color);
    .bloco-informacoes-adicionais-monitoramento-interno-texto1 {
        flex-wrap: wrap;
        font-size: 14px;
        font-weight: 500;
        margin-top: 7px;
    }
    .bloco-informacoes-adicionais-monitoramento__interno {
        display: flex;
        flex-direction: column;

        .bloco-informacoes-adicionais-monitoramento__interno-texto {
            display: flex;
            flex-direction: column;
            span {
                margin-top: 4px;
            }
        }
    }
    .bloco-informacoes-adicionais-monitoramento__interno--numero {
        flex-wrap: wrap;
        font-size: 14px;
        font-weight: 700;
    }
    .bloco-informacoes-adicionais-monitoramento-interno-texto2 {
        font-size: 14px;
        font-weight: 600;
    }

    &:first-child {
        margin: 2px 3px 2px 0px;
    }

    &:not(:first-child) {
        margin: 2px 3px 2px 2px;
    }
    .bloco-informacoes-adicionais-monitoramento__interno2 {
        display: flex;
        align-items: center;
    }
    .lista-scroll {
        max-height: 238px;
        overflow-y: auto;
        font-size: 14px;
        font-weight: 600;
        display: flex;
        flex-direction: column;
    }
}
@media only screen and (max-width: 1340px) {
    .bloco-informacoes-adicionais-monitoramento {
        min-width: 48% !important;
    }
}
</style>
